<template>
    <div>
        <b-tabs content-class="slu-dashboard-index-content" class="slu-dashboard-tabs apprentice-tab">
            <b-tab :title="$t('slu_dashboard.courses')" active>
                <design-2021-slu-dashboard-courses-index-tab-component
                    :slu-courses-in="sluCoursesIn"
                    :courses-in="coursesIn"
                >
                </design-2021-slu-dashboard-courses-index-tab-component>
            </b-tab>
            <b-tab :title="$t('slu_dashboard.students')">
                <design-2021-slu-dashboard-student-index-tab-component
                    :slu-students-in="sluStudentsIn"
                >
                </design-2021-slu-dashboard-student-index-tab-component>
            </b-tab>
            <b-tab :title="$t('slu_dashboard.settings')" v-if="$authUser.hasRoleOrAdmin('slu')">
                <design-2021-slu-dashboard-settings-tab-component
                    :slu-school-settings-in="sluSchoolSettingsIn"
                    :slu-status-tags-in="sluStatusTagsIn"
                    :slu-managers-in="sluManagersIn"
                    :slu-labels-in="sluLabelsIn"
                >
                </design-2021-slu-dashboard-settings-tab-component>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: "design-2021-slu-dashboard-index",
    props: ['sluCoursesIn','coursesIn','sluStudentsIn','sluStatusTagsIn','sluSchoolSettingsIn','sluManagersIn','sluLabelsIn'],
}
</script>

<style scoped>

</style>
